<div class="video-container snap-container m-2" *ngIf="!error">
  <span class="h4" [class.hide]="isFirstImageCaptured" role="alert" aria-live="polite"><b>{{language.ensureyourfacefillsthecircle}}</b></span>
  <span class="h4" [class.hide]="!isFirstImageCaptured || isSecondImageCaptured || (this.examsDontRequirePassportMatching$ | async)" role="alert" aria-live="polite"><b>{{language.smileForASecondPhoto}}</b></span>
</div>
<div class="video-container m-2" *ngIf="!error">
  <!-- <video class="candidate-video" [class.show]="!isCaptured" [class.hide]="isCaptured" #video id="video" playsinline autoplay [attr.aria-label]="language.liveVideoFeed"></video> -->
  <video class="candidate-video" #video id="video" playsinline autoplay [attr.aria-label]="language.liveVideoFeed" [hidden]="isFirstImageCaptured && (isSecondImageCaptured || (this.examsDontRequirePassportMatching$ | async))"></video>
  <canvas [class.show]="isFirstImageCaptured" [class.hide]="!isFirstImageCaptured" [class.afterFirstImageCaptured]="isFirstImageCaptured" #canvas id="canvas"  role="img" [attr.aria-label]="language.cameraPreview"></canvas>
</div>

<div class="snap-container mb-2">
  <button class="btn btn-danger" *ngIf="isFirstImageCaptured || isSecondImageCaptured"  (click)="removeCurrent()">
    {{language.startOver}}
  </button>
  <button class="btn btn-primary" *ngIf="!isFirstImageCaptured || (!isSecondImageCaptured && !(this.examsDontRequirePassportMatching$ | async))" (click)="capture()">
    {{!isFirstImageCaptured ? language.capturePhoto : language.captureSmilingPhoto}}
  </button>
  
  <button style="margin-left: 5px;" class="btn btn-success" *ngIf="isFirstImageCaptured && (isSecondImageCaptured || (this.examsDontRequirePassportMatching$ | async))" (click)="save()" [disabled]="this.saving">
    {{language.save}}
  </button>
  <div *ngIf="error" class="text-danger mt-4" role="alert" aria-live="assertive">
    {{ error }}.
    <div class="mt-5">
    </div>
  </div>
</div>

<!-- <div *ngIf="captured" class="thumbnail mb-2" (click)="save()" (keydown.enter)="save()">
  <img [src]="captured" height="70"  [alt]="language.capturedPhotoThumbnail"/>
  <button style="margin-left: 5px;" class="btn btn-success">{{language.upload}}</button>
</div> -->
